var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalliPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 549,
    height: 180,
    viewBox: "0 0 549 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_306",
    "data-name": "Groupe 306",
    transform: "translate(-76 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_307",
    "data-name": "Groupe 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2383",
    "data-name": "Trac\\xE9 2383",
    d: "M510.939,252.954a45.675,45.675,0,0,1-13.828,8.767,42.056,42.056,0,0,1-15.9,3.146,40.963,40.963,0,0,1-20.888-5.517,41.547,41.547,0,0,1-15.062-14.9,40.918,40.918,0,0,1,0-41.153,40.828,40.828,0,0,1,15.055-14.89,42.239,42.239,0,0,1,36.93-2.23,43.474,43.474,0,0,1,13.672,8.966l1.137,1.1,7.928-9.225-1.032-.968a55.917,55.917,0,0,0-65.211-7.806,54.11,54.11,0,0,0-19.848,19.129,50.3,50.3,0,0,0-7.356,26.544A51.409,51.409,0,0,0,433.81,250.6a54.241,54.241,0,0,0,46.961,26.507,53.271,53.271,0,0,0,20.538-4.173,60.438,60.438,0,0,0,17.774-11.285l1.1-1-8.151-8.679-1.085,1v-.015Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2384",
    "data-name": "Trac\\xE9 2384",
    d: "M424.177,306.385l-28-55.117-8.142,13.189,19.435,37.761-42.851.155L356.944,314.8l62.1.2a5.95,5.95,0,0,0,5.126-8.615Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2385",
    "data-name": "Trac\\xE9 2385",
    d: "M332.1,263.107H293.407l51.47-104.62,22.571,46.17,8.4-13.883-25.68-52.444a5.913,5.913,0,0,0-10.635-.007l-63.576,129.26a5.989,5.989,0,0,0,5.311,8.661h42.888l7.94-13.137Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2386",
    "data-name": "Trac\\xE9 2386",
    d: "M145.821,181.149c-7.2-6.05-17.442-9.116-30.47-9.116H76V276.244H89.117V243.5h26.234c13.035,0,23.287-3.2,30.485-9.5,7.251-6.345,10.925-15.4,10.925-26.889S153.079,187.258,145.821,181.149Zm-56.7,2.822H114.91c9.48,0,16.814,2.032,21.8,6.043,4.961,3.989,7.37,9.684,7.37,17.4s-2.439,13.777-7.46,17.913-12.331,6.25-21.707,6.25H89.117v-47.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2387",
    "data-name": "Trac\\xE9 2387",
    d: "M201.5,172.033H188.549V276.244h50.2l7.365-11.938H201.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2388",
    "data-name": "Trac\\xE9 2388",
    d: "M565,264.306v-35.14h51.987V217.228H565V183.964h58.107V172.033H551.972V276.244H625V264.306Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2389",
    "data-name": "Trac\\xE9 2389",
    d: "M91.935,291.6a7.965,7.965,0,0,1,3.57,2.976,9.121,9.121,0,0,1,0,9.182,7.944,7.944,0,0,1-3.57,2.991,13.33,13.33,0,0,1-5.463,1.034H81.024v6.979H76.541v-24.2h9.931A13.306,13.306,0,0,1,91.935,291.6ZM90.71,302.734a4.952,4.952,0,0,0,0-7.128,6.847,6.847,0,0,0-4.446-1.242h-5.24v9.613h5.24A6.888,6.888,0,0,0,90.71,302.734Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2390",
    "data-name": "Trac\\xE9 2390",
    d: "M124.333,290.569h4.483v20.394h12.618v3.8h-17.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2391",
    "data-name": "Trac\\xE9 2391",
    d: "M183.926,309.17H171.857l-2.382,5.6h-4.624l10.866-24.2h4.416l10.9,24.2h-4.691Zm-1.484-3.527-4.55-10.58-4.52,10.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2392",
    "data-name": "Trac\\xE9 2392",
    d: "M226.166,306.231v8.541h-4.483V306.3L212.2,290.577h4.795l7.066,11.785,7.14-11.785h4.416l-9.448,15.661Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalliPlace);
export default __webpack_public_path__ + "static/media/digitalli_place.ccaa88ff27663fd06e01acfa7960e5ab.svg";
export { ForwardRef as ReactComponent };